import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-gegevenswoordenboek',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconGegevenswoordenboek {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M30.99 7v-.03c0-.81-.32-1.57-.89-2.14-.57-.57-1.33-.88-2.13-.88h-.01l-19.91.07h-.03C7.46 4.02 7 3.56 7 3s.46-1.02 1.02-1.02h.03l19.91-.01C27.8 1.03 27 0 25.06 0H8C6.34 0 5 1.35 5 3.01L5.04 33c0 1.66 1.35 3 3 3h19.98c1.65 0 2.98-1.34 2.98-2.98V7zM24 19H12c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1"/>
</svg>

    );
  }
}
